import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import RangeDate from './range_date/RangeDate';
import useSettings from '../../../libs/settings/useSettings';
import { getVrrPreferences } from '../../../redux/settings/settingAction';
import { TDateRange } from './types';

const DateTimePicker: React.FC = () => {
  const { vrr } = useSettings();
  const datePickerPeriod = useSelector(getVrrPreferences)?.period;

  const onUpdate = (datePeriod: TDateRange) => {
    vrr({
      period: {
        from: moment(datePeriod.from).startOf('day'),
        to: moment(datePeriod.to).startOf('day')
      }
    });
  };

  return (
    <RangeDate
      onUpdate={onUpdate}
      datePickerPeriod={
        datePickerPeriod
          ? {
              from: moment(datePickerPeriod.from),
              to: moment(datePickerPeriod.to)
            }
          : undefined
      }
      format="YYYY-MM-DD"
      className="cy-datepicker-dropdown"
    />
  );
};

export default DateTimePicker;
